import React, {useContext} from 'react';
import clsx from 'clsx';

import {Theme} from '../contexts/theme';
import {getPlayOffStagesGridClassNames} from '../utils/getPlayOffStagesGridClassnames';

import Match from './match';

import styles from './play-off-stages-grid.module.css';

export default function PlayOffStagesGrid({list}) {
  const theme = useContext(Theme);
  const mapping = getPlayOffStagesGridClassNames(theme);

  return (
    list.map(({stage, matches}) => {
      const classNameBlockMatch = mapping[matches.length];
      const matchesClasses = clsx({
        [styles.matches]: true,
        [styles.matchesWrapped]: matches.length > 4
      });
      const matchBlockClasses = clsx({
        [classNameBlockMatch]: classNameBlockMatch,
        [styles.bottomIndent]: matches.length > 4
      });
      const stageClasses = clsx(styles.stageLabel, styles[`stageLabel${theme}`]);

      return (
        <div
          key={stage}
          className={styles.stageContainer}
        >
          <p className={stageClasses}>{stage}</p>
          <div className={matchesClasses}>
            {matches.map(({date, localTeam, visitorTeam, id}) => (
              <Match
                key={id}
                date={date}
                localTeam={localTeam}
                visitorTeam={visitorTeam}
                className={matchBlockClasses}
              />
            ))}
          </div>
        </div>
      );
    })
  );
}
